/** Lightweight UA → browser / OS / device for the click timeline. */

export function parseUserAgent(ua: string | null | undefined): {
	browser: string;
	os: string;
	device: string;
} {
	if (!ua) return { browser: "—", os: "—", device: "—" };

	const device = /Mobile|Android|iPhone|iPad/i.test(ua)
		? /iPad|Tablet/i.test(ua)
			? "Tablet"
			: "Mobile"
		: "Desktop";

	let os = "—";
	if (/Windows NT/i.test(ua)) os = "Windows";
	else if (/Mac OS X/i.test(ua)) os = "macOS";
	else if (/Android/i.test(ua)) os = "Android";
	else if (/iPhone|iPad|iOS/i.test(ua)) os = "iOS";
	else if (/Linux/i.test(ua)) os = "Linux";
	else if (/CrOS/i.test(ua)) os = "ChromeOS";

	let browser = "—";
	if (/Edg\//i.test(ua)) browser = "Edge";
	else if (/OPR\/|Opera/i.test(ua)) browser = "Opera";
	else if (/Chrome\//i.test(ua) && !/Edg\//i.test(ua)) browser = "Chrome";
	else if (/Safari\//i.test(ua) && !/Chrome\//i.test(ua)) browser = "Safari";
	else if (/Firefox\//i.test(ua)) browser = "Firefox";

	return { browser, os, device };
}
